module.exports = __webpack_public_path__ + "img/media_17.47c23d40.jpg";